
jQuery(document).ready(function($) {
	$(".header-wrapper").sticky({ topSpacing: 0 });
	// console.log("js is working");

	$(function() {
		$('.quality-header').matchHeight(
			{
				// byRow: false
			}
		);

	});



	$('.toggle-child').hide();
	$('.toggle-first-chiid').show();

	$('.toggle-header').click(function() {
		$(this).next('.toggle-child').slideToggle();
		$(this).toggleClass('toggle-active');
	});
	$('.toggle-bottom').click(function() {
		$(this).parent().parent().find('h2').toggleClass('toggle-active');
		$(this).parent().slideUp();

		$('html, body').animate({
			scrollTop: $($(this).parent().parent()).offset().top-8
		}, 1000);
	});
  
// soundest-form-background-image-overlay soundest-form-background-image-animated soundest-form-background-image-zero-opacity soundest-form-background-image-hidden
// https://forms.soundestlink.com/image/form/signupBox/60edb62a17f6736fb1c446a1
//.soundest-form-background-image-logo img
//   $('#my_image').attr('src','second.jpg');
	$('.close_rs').click( function() {
		$('.soundest-form-without-image-overlay').removeClass('soundest-form-without-image-zero-opacity soundest-form-without-image-hidden');
		$('.soundest-form-without-image').removeClass('soundest-form-without-image-hidden');
		$('.soundest-form-without-image-outer').removeClass('soundest-form-without-image-zero-opacity soundest-form-without-image-outer-open');

        $('.soundest-form-background-image-logo img').attr('src','https://forms.soundestlink.com/image/form/signupBox/60edb62a17f6736fb1c446a1');
        $('.soundest-form-background-image-overlay').removeClass('soundest-form-background-image-zero-opacity soundest-form-background-image-hidden');
        $('.soundest-form-background-image-outer').removeClass('soundest-form-background-image-zero-opacity soundest-form-background-image-outer-open');
        $('.soundest-form-background-image').removeClass('soundest-form-background-image-hidden');
        $('.soundest-form-background-image-content-inner').removeClass('soundest-form-background-image-bg-image-hidden');
  
        
        
        // $('.omnisend-reset-60edb5d9657e8b001aabf5cd.omnisend-form-60edb5d9657e8b001aabf5cd-container').css("display","flex");
        // $('.omnisend-form-60edb5d9657e8b001aabf5cd-teaser.omnisend-reset-60edb5d9657e8b001aabf5cd').trigger('click');
        // $('#omnisend-form-60edb5d9657e8b001aabf5cd-teaser-btn').trigger('click');
		window._klOnsite = window._klOnsite || [];
		window._klOnsite.push(['openForm', 'YbZw7b']);
        // $('.omnisend-form-60edb5d9657e8b001aabf5cd-close-action').bind( "click", function () {
          // $('.omnisend-reset-60edb5d9657e8b001aabf5cd.omnisend-form-60edb5d9657e8b001aabf5cd-container').css("display","none");
        // });
      
	} );

	var DetailsMenuDrawerContainer = $('#Details-menu-drawer-container');
	$('.drawer-close').click( function () {
		console.log('close');
		$('#shopify-section-header').removeClass('menu-open');
		$('body').removeClass('overflow-hidden-tablet');
		DetailsMenuDrawerContainer.removeClass('menu-opening');
		DetailsMenuDrawerContainer.removeAttr("open");
		$('.header__icon--menu').attr("aria-expanded","false");
	} );


	$('#myCarousel .item:first').addClass('active');
	var myCarousel = $("#myCarousel");

	myCarousel.owlCarousel({
		nav:false,
		loop:false,
		margin:40,
		slideBy: 1,
		navText: '',
		responsiveClass:true,
		responsive:{
			0:{
				nav: false,
				dots: true,
				margin: 0,
				items:1
			},
			600:{
				nav: false,
				dots: true,
				margin:10,
				items:2
			},
			750:{
				nav: false,
				dots: true,
				margin:10,
				items:3
			},
			1001:{
				dots: false,
				nav:true,
				margin:40,
				items:4,
			}
		}
	})


	function postsCarousel() {
		var checkWidth = $(window).width();
		var owlPost = $(".prod_slider");
		if (checkWidth > 749) {
			if (typeof owlPost.data('owl.carousel') != 'undefined') {
				owlPost.data('owl.carousel').destroy();
				owlPost.removeClass('owl-carousel owl-theme');
			}
			owlPost.removeClass('owl-carousel');
		} else if (checkWidth < 750) {
			owlPost.addClass('owl-carousel owl-theme');
			owlPost.addClass('owl-carousel');
			owlPost.owlCarousel({
				nav: false,
				navText: '',
				dots: true,
				margin:0,
				stagePadding: 30,
				items:1
			});

		}
	}
	postsCarousel();
	$(window).resize(postsCarousel);


	function pdpCarousel() {
		var checkWidth = $(window).width();
		var owlPost = $(".pdp-features-owl");
		if (checkWidth > 749) {
			if (typeof owlPost.data('owl.carousel') != 'undefined') {
				owlPost.data('owl.carousel').destroy();
				owlPost.removeClass('owl-carousel owl-theme');
			}
			owlPost.removeClass('owl-carousel');
		} else if (checkWidth < 750) {
			owlPost.addClass('owl-carousel owl-theme');
			owlPost.addClass('owl-carousel');
			owlPost.owlCarousel({
				nav: false,
				navText: '',
				dots: true,
				margin:10,
				items:1
			});

		}
	}
	pdpCarousel();
	$(window).resize(pdpCarousel);




	$('#doctors-carousel .item:first').addClass('active');
	var doctorsCarousel = $("#doctors-carousel");
	doctorsCarousel.owlCarousel({
		items: 1,
		loop:false,
		// margin:40,
		slideBy: 1,
		autoHeight: true,
		responsiveClass:true,
		navText: '',
		responsive:{
			1000:{
				dots: true,
				nav:false,
				margin:0,
				items:1,
			},
			1001:{
				dots: false,
				nav:true,
				margin:0,
				items:1,
			}
		}

	})


	$('#customers-carousel .item:first').addClass('active');
	var customersCarousel = $("#customers-carousel");
	customersCarousel.owlCarousel({
		items: 1,
		loop:false,
		// margin:40,
		slideBy: 1,
		autoHeight: true,
		responsiveClass:true,
		navText: '',
		responsive:{
			1000:{
				dots: true,
				nav:false,
				margin:0,
				items:1,
			},
			1001:{
				dots: false,
				nav:true,
				margin:0,
				items:1,
			}
		}

	})

	$('.qty-box .qty-btn').on('click', function(){
		var qty = parseInt($(this).parent('.qty-box').find('.product-form__input').val());
		if($(this).hasClass('qty-plus')) {
			qty++;
		}else {
			if(qty > 1) {
				qty--;
			}
		}
		qty = (isNaN(qty))?1:qty;
		$(this).parent('.qty-box').find('.product-form__input').val(qty);
	});

	if (window.location.search.indexOf('variant=') === -1) {
    	$('variant-radios input[type="radio"]:eq(0)').prop('checked', true);
	}
    $('variant-radios label').on('click', function() {
		setTimeout(function() {
			index = $('variant-radios input[type="radio"]:checked').index('variant-radios input[type="radio"]');

			console.log(index);

			$('.rc-selling-plans__dropdown>option:eq(' + index + ')').prop('selected', true);
			$('.rc-selling-plans__dropdown').trigger('change');
		}, 100);
	});

	doctorsCarousel = $('#doctors-carousel');
	customersCarousel = $('#customers-carousel');
	function noControls(carousel) {
		var slides = carousel.find(".owl-item").length;
		console.log(slides);
		if ( slides <= 1 ) {
			carousel.find('.owl-controls').hide();
			// $('owl-controls').hide();
			// $('owl-dots').hide();
		}
	}
	noControls(doctorsCarousel);
	noControls(customersCarousel);

  
});